import { z } from 'zod';
/**
 * «بريد الفواتير» (a buyer's e-mail for invoices): ONE rule for the parties API, the issue check of the
 * buyer's e-mail copy (WP-1b.4, MF-INV-010) and the editor's step-4 block, so that the web and the
 * API never disagree (BLOCK-1B-EMAIL-DESIGN §2.2). Trimmed, lower-cased, a valid address of at
 * most 254 characters.
 */
export const partyEmailSchema = z.string().trim().toLowerCase().email().max(254);
/** The state of a stored address (records written before the rule may hold an invalid one). */
export function buyerEmailState(email) {
    if (email === null || email === undefined || email.trim() === '')
        return 'missing';
    return partyEmailSchema.safeParse(email).success ? 'available' : 'invalid';
}
/** The address the copy goes to (normalised by the rule), or null when it is not usable. */
export function usableBuyerEmail(email) {
    if (email === null || email === undefined)
        return null;
    const parsed = partyEmailSchema.safeParse(email);
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=index.js.map